import React, { Component } from 'react'
import './index.less'
import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

/**
 * @param order 整体头像大小
 * @param name 用户名
 * @param avatar 用户头像（图片地址）
 * @param id 用户id
 * @param gold 用户金币
 * @author: KK
 * @desc: 用户排行榜模块封装
 */

export default class extends Component {
  jumpTo(userId) {
    if (this.props.userOrRoom == "user") {
      jumpToUser(userId)
    } else if (this.props.userOrRoom == "room") {
      jumpToRoom(userId)
    }
  }
  render() {
    const { order, avatar, name, id, gold, userId, userOrRoom } = this.props
    return (
      <div className='kk-rank-comp-wrap'>
        <div className="kk-rank-item">
          <div className="rank-index">{order}</div>
          <img className="rank-avatar" onClick={() => this.jumpTo(userId)} src={avatar} alt="" />
          <div className="user-info">
            <div className="name">{name}</div>
            <div className="id">ID:&nbsp;{id}</div>
          </div>
          <div className="gold">{score(gold)}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Rank/index.js